var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vliveHeader padding-20"},[_c('div',{staticClass:"vliveContent"},[_c('span',[_vm._v(_vm._s(_vm.item.subject))]),_c('span',[_vm._v(_vm._s(_vm.item.begintime))])])])}
var staticRenderFns = []

export { render, staticRenderFns }